import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import NotiAdminDetailComponent from "../../../components/Admin/noti_admins/NotiAdminDetailComponent";

const NotiAdminDetailPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirect = () => {
        navigate(-1);
    }

    return <NotiAdminDetailComponent notiAdminId={ params.notiAdminId } shouldRedirect={ () => redirect() } />;
}

export default NotiAdminDetailPage;